module.exports = "../dist/img/img_4-30.e848.jpg";